module.exports = __webpack_public_path__ + "fonts/qtzain_bold_final.1178956d.woff2";